import { render, staticRenderFns } from "./SelfReservations.vue?vue&type=template&id=2714d35b&"
import script from "./SelfReservations.vue?vue&type=script&lang=js&"
export * from "./SelfReservations.vue?vue&type=script&lang=js&"
import style0 from "./SelfReservations.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports